export const STATSIG_CLIENT_KEY =
  process.env.REACT_APP_STATSIG_CLIENT_KEY ?? "";
export const STATSIG_ENV_TIER = process.env.REACT_APP_STATSIG_ENV_TIER ?? "";

export const PAY_BEFORE_SETUP_CAMPAIGN_GATE = "pay_before_setup_campaign_gate";

export const PAY_BEFORE_SETUP_BLOCKED_ROUTES = [
  "/collabs",
  "/campaigns",
  "/applications",
  "/creators",
  "/report",
  "/messenger",
  "/settings",
] as const;
